<template>
  <div class="detailed-statistic">
    <div class="page-header">
      <h1 class="page-title">{{ campaignName }}</h1>
      <a href="/campaigns" class="btn-secondary">{{ $t('messages.back') || 'Back' }}</a>
    </div>

    <div v-if="dates.length === 0" class="empty-state">
      {{ $t('messages.no_data') || 'No statistic data available for this campaign.' }}
    </div>

    <table v-else class="stats-table">
      <thead>
        <tr>
          <th>{{ $t('messages.date') || 'Date' }}</th>
          <th>{{ $t('messages.impressions') || 'Impressions' }}</th>
          <th>{{ $t('messages.clicks') || 'Clicks' }}</th>
          <th>{{ $t('messages.views') || 'Views' }}</th>
          <th>{{ $t('messages.revenue') || 'Revenue' }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in dates" :key="row.id || row.date">
          <td>{{ row.date }}</td>
          <td>{{ row.impressions ?? 0 }}</td>
          <td>{{ row.clicks ?? 0 }}</td>
          <td>{{ row.views ?? 0 }}</td>
          <td>{{ row.revenue ?? 0 }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'DetailedStatistic',
  props: {
    campaign: { type: Object, default: () => ({}) },
    dates: { type: Array, default: () => [] },
    user: { type: Object, default: () => ({}) },
    ages: { type: Array, default: () => [] },
    creatives: { type: Array, default: () => [] },
    currency: { type: [Object, String, null], default: null },
    device_types: { type: Array, default: () => [] },
    environments: { type: Array, default: () => [] },
    genders: { type: Array, default: () => [] },
    geographies: { type: Array, default: () => [] },
    operating_systems: { type: Array, default: () => [] },
    titles: { type: Array, default: () => [] },
  },
  computed: {
    campaignName() {
      return this.campaign?.campaign || this.campaign?.name || `#${this.campaign?.id || ''}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.detailed-statistic {
  padding: 24px;

  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  .stats-table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      border: 1px solid #e0e0e0;
      padding: 8px 12px;
      text-align: left;
    }

    th {
      background: #f5f5f5;
    }
  }

  .empty-state {
    color: #666;
    padding: 24px 0;
  }
}
</style>
